import { Injectable } from '@angular/core';
import { Vehiculo } from '../interfaces/vehiculo';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfHttpService } from './conf-http.service';
import { AuthService } from '../CookieAuth/auth.service';
@Injectable({
  providedIn: 'root'
})
export class VehiculoService {
  // endpopint = 'http://api.crabslogistica.dotsystems.com.ar/api/';
  // endpopint = 'http://localhost:8000/api/';
  endpopint = '';
  vehiculos?:Vehiculo[];
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, conf:ConfHttpService, private cookie: AuthService) {
    this.endpopint=conf.getBackend();
    this.headers= new HttpHeaders({'Content-Type': 'application/json'});
   }
  getVehiculos()
{
  return this.http.get<Vehiculo[]>(this.endpopint+'vehiculos');

  // return this.vehiculos
  }
  getVehiculosById(id:number)
{
  return this.http.get<Vehiculo>(this.endpopint+'getVehiculoById/'+ id);

  }
  postNuevo(vehiculo:Vehiculo){
    vehiculo.token= this.cookie.getCookie();

    return this.http.post<any>(this.endpopint+'vehiculos',vehiculo, {headers: this.headers}).toPromise()
  }
  put(vehiculo:Vehiculo){
    vehiculo.token= this.cookie.getCookie();

    return this.http.put<any>(this.endpopint+'vehiculos/'+ vehiculo.id,vehiculo, {headers: this.headers}).toPromise()
  }
  delete(id:number){
    // vehiculo.token== this.cookie.getCookie();
    return this.http.delete<any>(this.endpopint+'vehiculos/'+ id, {headers: this.headers}).toPromise()
  }
}
